module.exports = __webpack_public_path__ + "static/media/bell-cowbell2.9eed153a.aac";